import { reatomAsync } from "@reatom/async";

import { utmAtom } from "../atoms/utmAtom";

/**
 * Извлекает UTM-параметры из URL и сохраняет их в cookie
 */
const getUtmParamsFromUrl = () => {
  const params = new URLSearchParams(window.location.search);
  return {
    utm_source: params.get("utm_source") || undefined,
    utm_medium: params.get("utm_medium") || undefined,
    utm_campaign: params.get("utm_campaign") || undefined,
    utm_content: params.get("utm_content") || undefined,
    utm_term: params.get("utm_term") || undefined,
  };
};

export const setUtmParamsAction = reatomAsync(async (ctx) => {
  const utmParams = getUtmParamsFromUrl();
  const currentUtm = ctx.get(utmAtom.cookieAtom);

  const cookieOptions = {
    path: "/",
    maxAge: 60 * 60 * 24 * 30, // 30 дней
  };

  // Сохраняем UTM-параметры только если они есть в URL и еще не сохранены в cookie
  // Это позволяет сохранять параметры при первом визите с UTM-метками
  if (utmParams.utm_source && !currentUtm.utm_source) {
    utmAtom.set(ctx, "utm_source", utmParams.utm_source, cookieOptions);
  }

  if (utmParams.utm_medium && !currentUtm.utm_medium) {
    utmAtom.set(ctx, "utm_medium", utmParams.utm_medium, cookieOptions);
  }

  if (utmParams.utm_campaign && !currentUtm.utm_campaign) {
    utmAtom.set(ctx, "utm_campaign", utmParams.utm_campaign, cookieOptions);
  }

  if (utmParams.utm_content && !currentUtm.utm_content) {
    utmAtom.set(ctx, "utm_content", utmParams.utm_content, cookieOptions);
  }

  if (utmParams.utm_term && !currentUtm.utm_term) {
    utmAtom.set(ctx, "utm_term", utmParams.utm_term, cookieOptions);
  }
}, "setUtmParamsAction");
